import useStageStore from '../stores/useStageStore';
import usePropertiesStore from '../stores/usePropertiesStore';
import useDesignStore from '../stores/useDesignStore';
import useProductStore from '../stores/useProductStore';
import useLayersStore from '../stores/useLayersStore';

/** Clears editor/session state when the graphic route (project/design) changes or before a fresh bootstrap. */
export function resetGraphicEditorRouteState() {
  useStageStore.getState().reset();
  usePropertiesStore.getState().reset();
  useDesignStore.getState().reset();
  useProductStore.getState().reset();
  useLayersStore.getState().reset();
}
